<template>
  <div class="container_box">
    <div class="bg">
      <img src="../assets/imgs/banner1-1.png" alt="" />
    </div>
    <div class="content">
      <!-- 竞价大厅标题 -->
      <div class="flex between mb-20 pt-15">
        <div class="bold9 size20 color1">
          系统公告
          <!-- <span style="font-size: 14px; color: #ccd9e9"> System Bulletin</span> -->
        </div>
      </div>
      <!-- 内容 -->
      <div class="flex between">
        <!-- 列表 -->
        <div>
          <div class="listBox" v-if="list.length > 0">
            <div
              class="list flex between pointer"
              v-for="(item, index) in list"
              :key="index"
              @click="goDetail(item.id)"
            >
              <span>{{ item.title }}</span>
              <span>{{ item.publishTime }}</span>
            </div>
          </div>
          <div class="listBox flex flex-center items-center" v-else>
            暂无数据
          </div>
          <!-- 分页 -->
          <div
            v-if="list.length > 0"
            style="width: 855px; margin-top: 10px; padding: 17px 50px 17px 0px"
            class="bg-color border-box"
          >
            <el-pagination
              class="pagination flex flex-end"
              prev-text="上一页"
              next-text="下一页"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-size="queryInfo.pageSize"
              :current-page="queryInfo.pageNum"
              layout="prev,pager, next,slot"
              :total="total"
            >
              <div style="color: #ccd9e9; margin-left: 160px">
                到第<el-input v-model="queryInfo.pageNum"></el-input>页/共{{
                  Math.ceil(total / queryInfo.pageSize)
                }}页
              </div>
              <div class="btn" @click="getSysAnnList">确定</div>
            </el-pagination>
          </div>
        </div>
        <!-- 图片 -->
        <img
          style="width: 324px; height: 397px"
          src="../assets/imgs/gonggao.png"
          alt=""
        />
      </div>
    </div>
    <Footer class="mt-15" />
  </div>
</template>

<script>
import Footer from "@/components/Footer";

export default {
  components: { Footer },

  data() {
    return {
      list: [],
      queryInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      total: 0,
    };
  },
  created() {
    //获取系统公告列表
    this.getSysAnnList();
  },
  methods: {
    async getSysAnnList() {
      this.queryInfo.pageNum = parseInt(this.queryInfo.pageNum);

      const { data: res } = await this.$axios.get(
        "/api/annInfo/getSysAnnList",
        {
          params: this.queryInfo,
        }
      );
      if (res.code == 200) {
        this.list = res.rows;
        this.total = res.total;
      } else {
        console.log(res);
      }
    },
    goDetail(id) {
      this.$router.push({
        path: `/Xtggxq/`,
        query: {
          id,
        },
      });
    },
    //分页效果
    handleSizeChange(val) {
      this.queryInfo.pageSize = val;
      this.getSysAnnList();
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNum = val;
      this.getSysAnnList();
    },
  },
};
</script>

<style scoped lang="less">
.content_box {
  background: url("../assets/imgs/bg.png") no-repeat;
  padding-bottom: 43px;
}
.content {
  width: 1200px;
  margin: auto;
}

/deep/.pagination.el-pagination span {
  width: 80px;
  height: 30px;
  border: 1px solid #1c65c4;
  border-radius: 25px;
  color: #3b426b;
  font-weight: bold;
  font-size: 14px;
}
/deep/.pagination.el-pagination li {
  color: #ccd9e9;
}
/deep/.pagination.el-pagination li.active {
  color: #3b426b;
}
/deep/.el-pagination .el-input {
  margin-right: 0 !important;
  width: 40px;
}
/deep/.el-pagination .el-input__inner {
  width: 40px;
  height: 30px;
  border: 1px solid #ccd9e9;
  border-radius: 8px;
}
.btn {
  width: 80px;
  height: 30px;
  border-radius: 25px;
  background-color: #1c65c4;
  color: #fff;
  text-align: center;
  line-height: 30px;
  margin-left: 24px;
  cursor: pointer;
}
.listBox {
  width: 855px;
  // height: 855px;
  min-height: 400px;
  background-color: #fff;
  padding: 32px 40px;
  box-sizing: border-box;
}
.list {
  border-bottom: 2px solid #95b3db;
  box-sizing: border-box;
  padding-bottom: 20px;
  margin-bottom: 16px;
  span {
    font-size: 16px;
    color: #3b426b;
  }
}
</style>